/* eslint-disable */
import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { getSrcSet, getSizes, buildCmsUrl } from "../../utils/imageHelper";



declare const window: any;

interface ContenidoComponentProps {
  setSelectedCategories: any;
  selectedCategories: any;
  vehiculos: any;
  modelos: any;
}

const ContenidoComponent: React.FC<ContenidoComponentProps> = ({
  setSelectedCategories,
  selectedCategories,
  vehiculos,
  modelos,
}) => {
  const [visibleCategories, setVisibleCategories] = useState<Set<string>>(
    new Set()
  );
  const refs = useRef<{ [key: string]: HTMLDivElement | null }>({});

  const info_request_click = (vehiculo: any) => {

    const dataLayerEvent: any = {
      event: "info_request_click",
      comp_product: {
        position: "page",
        vehicle_type: "Car",
        brand: "Hyundai",
        product_condition: vehiculo?.is_new ? "new" : null,
        model: `${
          modelos?.find(
            (e: any) =>
              e.internal?.trim().toLowerCase() ===
              vehiculo?.title?.trim().toLowerCase()
          )?.nombremodelo
        }`,
        version: null,
        fuel_type: null,
        dealer_name: null,
      },
    };

    // Empujar al dataLayer
    if (window.dataLayer) {
      window.dataLayer.push(dataLayerEvent);
    }
  };

  const file_download = (vehiculo: any) => {
    // Usar setTimeout para evitar bloquear el hilo principal durante la descarga
    setTimeout(() => {
      const dataLayerEvent: any = {
        event: "file_download",
        comp_page: {
          file_name: null,
          link: `${vehiculo?.url_brochure}`,
          vehicle_type: "Car",
          brand: "Hyundai",
          product_condition: vehiculo?.is_new ? "new" : null,
          model: vehiculo?.title || "unknown",
          file_type: "catalog",
          download_type: "preview",
        },
      };

      if (window.dataLayer) {
        window.dataLayer.push(dataLayerEvent);
      }
    }, 0);
  };

  const checkInitialVisibility = () => {
    Object.keys(refs.current).forEach((category) => {
      const currentRef = refs.current[category];
      if (currentRef) {
        const rect = currentRef.getBoundingClientRect();
        if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
          setVisibleCategories((prev) => new Set(prev).add(category));
        }
      }
    });
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const category = entry.target.getAttribute("data-category");
          if (category) {
            setVisibleCategories((prev) => {
              const newVisibleCategories = new Set(prev);
              if (entry.isIntersecting) {
                newVisibleCategories.add(category);
              } else if (entry.boundingClientRect.top > 0) {
                newVisibleCategories.delete(category);
              }
              return newVisibleCategories;
            });
          }
        });
      },
      {
        threshold: 0.1,
      }
    );

    const timeoutId = setTimeout(() => {
      Object.keys(refs.current).forEach((category) => {
        const currentRef = refs.current[category];
        if (currentRef) {
          observer.observe(currentRef);
        }
      });
      checkInitialVisibility();
    }, 100);

    return () => {
      clearTimeout(timeoutId);
      Object.keys(refs.current).forEach((category) => {
        const currentRef = refs.current[category];
        if (currentRef) {
          observer.unobserve(currentRef);
        }
      });
    };
  }, [vehiculos, selectedCategories]);

  return (
    <div className="contenido-vehiculos-component">
      {vehiculos
        .sort((a: any, b: any) => a.order - b.order)
        .filter(
          (categoria: any) =>
            (selectedCategories === "Todos" && categoria?.is_menu_all) ||
            categoria.category === selectedCategories
        )
        .map((categoria: any) => (
          <div
            className="categoria-contenido-vehiculos-component"
            key={categoria.category}
          >
            {/* TÍTULO DE CATEGORÍA - CAMBIADO A H2 */}
            <h2 className="title-categoria-contenido-vehiculos-component">
              {categoria.category}
            </h2>
            
            <div
              className={`vehiculos-categoria-contenido-vehiculos-component ${
                visibleCategories.has(categoria.category) ? "visible" : ""
              }`}
              ref={(el) => (refs.current[categoria.category] = el)}
              data-category={categoria.category}
            >
              {categoria.vehicles_cards
                .sort((a: any, b: any) => {
                  const priseA = parseInt(a.price.replace(/\$|,|\./g, ""));
                  const priseB = parseInt(b.price.replace(/\$|,|\./g, ""));
                  return priseA - priseB;
                })
                .map((vehiculo: any, index: number) => (
                  <div
                    className={`vehiculo-categoria-contenido-vehiculos-component ${
                      vehiculo?.is_new ? "new" : ""
                    }`}
                    key={vehiculo?.title}
                  >
                    {/* NUEVO - CAMBIADO A H3 */}
                    {vehiculo?.is_new && (
                      <h3 className="new-vehiculo-categoria-contenido-vehiculos-component">
                        ¡Nuevo!
                      </h3>
                    )}
                    
                    <Link
                      to={vehiculo?.url_quote}
                      onClick={() => info_request_click(vehiculo)}
                    >
                      <img
                        className="img-vehiculo-categoria-contenido-vehiculos-component"
                        loading={index < 2 ? "eager" : "lazy"}
                        {...({ fetchpriority: index < 2 ? "high" : "auto" } as any)}
                        src={buildCmsUrl(vehiculo?.image?.url)}
                        srcSet={getSrcSet(vehiculo?.image?.url)}
                        sizes={getSizes('350px')}
                        alt={`Imagen del vehículo ${vehiculo?.title}`}
                      />

                    </Link>

                    {/* TÍTULO DEL VEHÍCULO - CAMBIADO A H3 */}
                    <h3 className="label-vehiculo-categoria-contenido-vehiculos-component">
                      {vehiculo?.title}
                    </h3>
                    
                    <p className="precio-vehiculo-categoria-contenido-vehiculos-component">
                      desde {vehiculo?.price}
                    </p>
                    
                    <div className="detalle-vehiculo-categoria-contenido-vehiculos-component">
                      <div>
                        <img
                          loading="lazy"
                          src={buildCmsUrl(vehiculo?.icon1?.url)}
                          srcSet={getSrcSet(vehiculo?.icon1?.url)}
                          sizes={getSizes('30px')}
                          alt={vehiculo?.text1 || "Combustible"}
                        />

                        <span>{vehiculo?.text1}</span>
                      </div>
                      <div>
                        <img
                          loading="lazy"
                          src={buildCmsUrl(vehiculo?.icon2?.url)}
                          srcSet={getSrcSet(vehiculo?.icon2?.url)}
                          sizes={getSizes('30px')}
                          alt={vehiculo?.text2 || "Motor"}
                        />

                        <span>{vehiculo?.text2}</span>
                      </div>
                      <div>
                        <img
                          loading="lazy"
                          src={buildCmsUrl(vehiculo?.icon3?.url)}
                          srcSet={getSrcSet(vehiculo?.icon3?.url)}
                          sizes={getSizes('30px')}
                          alt={vehiculo?.text3 || "Garantía"}
                        />

                        <span>{vehiculo?.text3}</span>
                      </div>
                    </div>

                    {/* BOTONES - ORIGINALES SIN MODIFICAR (SIN H4) */}
                    <div className="opcion-vehiculo-categoria-contenido-vehiculos-component">
                      <Link
                        to={vehiculo?.url_quote}
                        onClick={() => info_request_click(vehiculo)}
                        className="cotiza-opcion-vehiculo-categoria-contenido-vehiculos-component"
                      >
                        Cotiza
                      </Link>
                      <Link
                        to={vehiculo?.url_reserve || "#"}
                        className={`reserva-opcion-vehiculo-categoria-contenido-vehiculos-component ${
                          !vehiculo?.url_reserve ? "inactive" : ""
                        } ${!vehiculo?.url_brochure ? "active" : ""}`}
                      >
                        Reserva
                      </Link>
                      <a
                        href={vehiculo?.url_brochure || "#"}
                        onClick={() => file_download(vehiculo)}
                        target="_blank"
                        className={`pdf-opcion-vehiculo-categoria-contenido-vehiculos-component ${
                          !vehiculo?.url_brochure ? "inactive" : ""
                        } ${!vehiculo?.url_reserve ? "active" : ""}`}
                      >
                        Ficha técnica
                      </a>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        ))}
    </div>
  );
};

export default ContenidoComponent;